const matrixes = document.querySelectorAll('.product-matrix');
const rowOpenClass = 'matrix__row--open';

const getMaxHeight = (items) => {
  return +Math.max(...items.map((item) => item.scrollHeight));
};

const initRowClick = (matrix) => {
  const rows = matrix.querySelectorAll('.matrix__row');

  rows.forEach((row) => {
    row.addEventListener('click', ({ currentTarget }) => {
      // don't do any manipulation if there's no additional text
      if (currentTarget.classList.contains('matrix__row--no-open')) {
        return;
      }

      const infos = [...currentTarget.querySelectorAll('.matrix__value-info')];
      const maxHeight = infos.length ? getMaxHeight(infos) : 0;

      if (row.classList.contains(rowOpenClass)) {
        row.style.setProperty('--info-height', `0px`);
        row.classList.remove(rowOpenClass);
      } else {
        row.style.setProperty('--info-height', `${maxHeight}px`);
        row.classList.add(rowOpenClass);
      }
    });
  });
};

(() => {
  if (matrixes.length) {
    matrixes.forEach((matrix) => {
      initRowClick(matrix);
    });
  }
})();
